import React from 'react';
import { AuthHeading } from '../../auth/partials';
import t from '@i18n/t';
import { tryAgain, useConnection } from '@utils/maintenance';
import { Container, Message, MessageWrapper, TryAgainLink } from './MaintenancePage';

/**
 * Shovel opened with no internet: the app can't load its data, so this shows instead of an empty page. It opens by
 * itself once the internet is back (utils/maintenance.ts). Not loaded on demand: it has to be there offline.
 */
const OfflinePage = () => {
  const { checking } = useConnection();

  return (
    <Container>
      <AuthHeading title={t.OFFLINE_TITLE} />
      <MessageWrapper>
        <Message>{t.OFFLINE_TEXT}</Message>
      </MessageWrapper>
      <TryAgainLink checking={checking} onClick={tryAgain} />
    </Container>
  );
};

export default OfflinePage;
